/** A connection request the server refused, with its status and reason. */
export class ConnectionApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
    /** Stable code of the service for a more precise message, if any. */
    readonly reason?: string
  ) {
    super(message);
    this.name = 'ConnectionApiError';
  }
}
